"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@mui/material");
var _wouter = require("wouter");
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _SideBar = _interopRequireDefault(require("./SideBar"));
var _Courses = _interopRequireDefault(require("./Courses"));
var _CourseDetail = _interopRequireDefault(require("./CourseDetail"));
var _LessonDetail = _interopRequireDefault(require("./LessonDetail"));
var _LessonExam = _interopRequireDefault(require("./LessonExam"));
var _LessonExamResult = _interopRequireDefault(require("./LessonExamResult"));
var _MyPage = _interopRequireDefault(require("./MyPage"));
var _Style = require("../../style/Style");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function App() {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
    container: true,
    ...stylex.props(_Style.wrapper.fill),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Grid2, {
      ...stylex.props(_Style.wrapper.sidebarOuter),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SideBar.default, {})
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Grid2, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_wouter.Switch, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_wouter.Route, {
          path: "/courses",
          component: _Courses.default
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_wouter.Route, {
          path: "/course/detail/:id",
          children: params => /*#__PURE__*/(0, _jsxRuntime.jsx)(_CourseDetail.default, {
            id: params.id
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_wouter.Route, {
          path: "/course/:courseId/lesson/:lessonId",
          children: params => /*#__PURE__*/(0, _jsxRuntime.jsx)(_LessonDetail.default, {
            courseId: params.courseId,
            lessonId: params.lessonId
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_wouter.Route, {
          path: "/course/:courseId/lesson/:lessonId/exam",
          children: params => /*#__PURE__*/(0, _jsxRuntime.jsx)(_LessonExam.default, {
            courseId: params.courseId,
            lessonId: params.lessonId
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_wouter.Route, {
          path: "/course/:courseId/lesson/:lessonId/exam-result",
          children: params => /*#__PURE__*/(0, _jsxRuntime.jsx)(_LessonExamResult.default, {
            courseId: params.courseId,
            lessonId: params.lessonId
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_wouter.Route, {
          path: "/mypage",
          component: _MyPage.default
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_wouter.Route, {
          path: "*",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_wouter.Redirect, {
            to: "/courses"
          })
        })]
      })
    })]
  });
}
var _default = exports.default = App;